<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">

                        <!-- Dashboard Box -->
                        
                        <div class="col-xl-12">

                            <div class="row">
                                <!-- Dashboard Box -->

                                <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                                    <div class="tabs tabs-default margin-top-0 margin-bottom-20">
                                        <div class="tabs-header">
                                            <ul style="width: 100%;">
                                                <li style="width: 50%;" v-bind:class="{'active': tab == 'gerenciamento'}">
                                                    <a v-on:click="setTab('gerenciamento')">
                                                        <i class="material-icons">edit</i>
                                                        Gerenciamento
                                                    </a>
                                                </li>
                                                <li style="width: 50%;" v-bind:class="{'active': tab == 'visualizacoes'}">
                                                    <a v-on:click="setTab('visualizacoes')">
                                                        <i class="material-icons">remove_red_eye</i>
                                                        Visualizações
                                                    </a>
                                                </li>                                        
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-xl-12" v-show="tab == 'gerenciamento'">

                                    
                                    <router-link :to="{'name': 'CadastrarNotificacoes'}" class="button big block-mobile margin-bottom-15">
                                        <i class="material-icons">add</i>
                                        Novo lembrete
                                    </router-link>
                                

                                    <div v-show="data.itens.length == 0 && data.loaded" class="job-overview empty">
                                        <div class="job-overview-inner">
                                            <center>
                                                <i class="material-icons big">mood_bad</i>
                                                <p>Nenhum resultado encontrado.</p>
                                            </center>
                                        </div>      
                                    </div>

                                    <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                        <table class="table table-bordered table-bordered-default table-responsive">
                                            <thead>
                                                <th style="min-width: 1px; width: 1px;">
                                                    ID
                                                </th>
                                                <th style="min-width: 200px;">
                                                    Mensagem
                                                </th>
                                                <th style="min-width: 200px; width: 200px;">
                                                    Destinatário(s)
                                                </th>                                         
        <!--                                         <th style="min-width: 200px; width: 200px;">
                                                    Detalhes
                                                </th> -->
                                                <th style="min-width: 128px; width: 128px;">
                                                    Ações
                                                </th>                                                                     
                                            </thead>
                                            <tbody>   

                                                <tr v-for="(item, index) in data.itens">
                                                    <td data-label="ID">
                                                        #{{item.id}}
                                                    </td>
                                                    <td data-label="Mensagem">
                                                        <p class="margin-bottom-0" style="font-size: 18px;"><b>{{item.titulo}}</b></p>
                                                        <div v-html="item.texto.replace(/(?:\r\n|\r|\n)/g, '<br>')"></div>
                                                        <div  class="margin-top-5">
                                                            <small v-if="item.fixo == 1">
                                                                <i class="material-icons">warning</i>
                                                                Lembrete fixo
                                                                <br>
                                                            </small>
                                                            <small v-if="item.confirmacao == 1">
                                                                <i class="material-icons">check_circle</i>
                                                                Confirmação de leitura
                                                                <br>
                                                            </small>                                                            
                                                            <small v-if="item.recorrente == 1">
                                                                <i class="material-icons">event</i>
                                                                Envio todo dia <b>{{item.dia}}</b> às <b>{{item.hora}}</b>
                                                                <br>
                                                            </small>
                                                            <small v-if="item.ultimoEnvio != '0000-00-00 00:00:00'">
                                                                <i class="material-icons">access_time</i>
                                                                Enviado em: {{item.ultimoEnvio | formatDate}}
                                                            </small>
                                                        </div>   
                                                    </td>                                         
                                                    <td data-label="Destinatário(s)">
                                                        <small v-for="(item2, index2) in item.destinatarios">
                                                            ● {{item2.nome}} 
                                                            <br>
                                                        </small>
                                                    </td>                  
                                                    <td data-label="Ações">
                                                        <router-link :to="{'name': 'EditarNotificacoes', 'query': {'c': item.cod}}" class="dashboard-status-button gray">
                                                            Editar
                                                        </router-link>
                                                        <a class="dashboard-status-button color-red" v-on:click="del(item.cod)">
                                                            Apagar
                                                        </a>                                                                                      
                                                    </td>                                                                                                                                       
                                                </tr>
                                            </tbody>
                                        </table>
                                    
                                    </div>
                                </div>

                                <div class="col-xl-12" v-show="tab == 'visualizacoes'">

                                    <h4 class="margin-bottom-20">
                                        <i class="material-icons">list</i>
                                        <b>Histórico de visualizações</b>
                                    </h4>

                                    <div v-show="visualizacoes.itens.length == 0 && visualizacoes.loaded" class="job-overview empty">
                                        <div class="job-overview-inner">
                                            <center>
                                                <i class="material-icons big">mood_bad</i>
                                                <p>Nenhum resultado encontrado.</p>
                                            </center>
                                        </div>      
                                    </div>

                                    <div class="row">
                                        <div class="col-xl-4 col-lg-6 col-md-6 col-xs-12" v-for="(item, index) in Object.keys(visualizacoes.itens)">
                                            <div class="dashboard-box mobile margin-top-0 margin-bottom-15">

                                                <!-- Headline -->
                                                <div class="headline padding-10" style="background: #efefef; padding: 10px 20px 5px 10px;">
                                                    <h3 class="margin-bottom-0" style="height: 24px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                                        <strong style="color: #999;">[#{{visualizacoes.itens[item][0].notificacao.id}}]</strong> 
                                                        <b>{{visualizacoes.itens[item][0].notificacao.titulo}}</b>
                                                    </h3>
                                                    <small style="height: 20px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block;">
                                                        {{visualizacoes.itens[item][0].notificacao.texto}}
                                                    </small>  
                                                    <small v-if="visualizacoes.itens[item][0].notificacao.ultimoEnvio != '0000-00-00 00:00:00'" style="color: #999;">
                                                        <i class="material-icons" style="font-size: inherit;">access_time</i>
                                                        Enviado em: {{visualizacoes.itens[item][0].notificacao.ultimoEnvio | formatDate}}
                                                    </small>                                                                                                      
                                                </div>

                                                <div class="content padding-bottom-0">
                                                    <div class="row">
                                                        <div class="col-xl-12">
                                                            <h5 class="padding-left-20 margin-top-10">
                                                                <i class="material-icons">remove_red_eye</i>
                                                                Visualizações:
                                                            </h5>
                                                            <hr style="margin-left: 20px; margin-right: 20px; opacity: 0.2;">
                                                            <ul>   
                                                                <li v-for="(item2, index2) in visualizacoes.itens[item]">
                                                                   
                                                                    {{item2.usuario.nome}}
                                                                    <br>
                                                                    <small>
                                                                        <i class="material-icons">access_time</i>
                                                                        {{item2.datahora | formatDate}}
                                                                    </small>

                                                                </li>

                                                            </ul>
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                
                                        </div>                                
                                    </div>                                
                                </div>                                
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Notificacoes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        nl2br: function(str) {
            return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
        },    
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  "gerenciamento",
            "visualizacoes":        {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "lidas":                 {
                "itens":            []
            },            
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            }              
        }
    },
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;
            if (tab == "visualizacoes") {
                self.getVisualizacoes();
            }
        },         
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/notificacoes.php", {params: self.form, db: "notificacoes"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getVisualizacoes: function() {
            var self        = this;
            console.log("getVisualizacoes()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "contratante") {
                    resolve(null);
                    return false;
                }
                var form = {
                    "db":               "notificacoes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "visualizacoes"
                    }
                };       
                axios.get("api/notificacoes.php", form)
                .then(response => {
                    
                    console.log("getVisualizacoes() response", response);
                    self.visualizacoes  = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getVisualizacoes() error", error.response);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },           
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/notificacoes.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.get();
            });
        } else {
            self.get();
        }          
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    td b {
        color: #000;
    }   
    .dashboard-box .headline h3 {
        color: #000;
        font-size: 18px;
    }
    .dashboard-box .content li {
        margin-top: 10px;
        font-size: 14px;
        color: #666;
        line-height: 130%;
    }
    .dashboard-box .content li i {
        position: relative;
        font-size: inherit;
    }

    .dashboard-box .content {
        overflow-x: hidden !important;
        height: 300px;
        overflow-y: scroll;
        padding-right: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Notificacoes.vue